export const styles = () => ({
  buttonsHolder: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: '24px 70px',
  },
})
